import classNames from "classnames"
import { ScheduleLesson } from "../../../api/model/Timetable"

interface LessonProps {
  lesson: ScheduleLesson
  hideTeacher?: boolean
}

const Lesson = (props: LessonProps) => {
  const { lesson, hideTeacher } = props
  if (lesson.isContinuation) return null

  const hasRoomChange = lesson.type === "rmchg"
  const isCanceled = lesson.type === "cancel"
  const isRoomReservation = lesson.type === "rmres" || lesson.type === "block"
  // Reservations matched via course tokens show title and room only; the rest of their
  // comment is meant for the timetable web app. Other reservations keep showing their comment.
  const isTokenMatchedReservation = isRoomReservation && (lesson.reservationTokens?.length ?? 0) > 0
  const message = isRoomReservation && !isTokenMatchedReservation ? lesson.message : undefined
  const showMessage = Boolean(message && message !== lesson.title)

  return (
    <div
      className={classNames("lesson", {
        "has-room-change": hasRoomChange,
        "is-canceled": isCanceled,
      })}
    >
      <div className="lesson-title">{lesson.title}</div>
      <div className="lesson-room">{lesson.room}</div>
      {showMessage && <div className="lesson-message">{message}</div>}
      {!hideTeacher && !isRoomReservation && (
        <div className="lesson-teacher">
          {isCanceled ? <span className="cancel-notice">Ausfall</span> : lesson.teacher}
        </div>
      )}
    </div>
  )
}

export default Lesson
